module.exports = __webpack_public_path__ + "img/email.42d9148e.svg";